import { useState, useRef, useEffect } from 'react';

function useOnScreen(offset = 0, once = false) {
    const [intersecting, setIntersecting] = useState(false);
    const ref = useRef();
    const observerOptions = {
        rootMargin: `0px 0px ${offset}px 0px `,
    };
    useEffect(() => {
        if (!ref.current) {
            return null;
        }
        const observer = new IntersectionObserver(([entry]) => {
            if (once) {
                if (entry.isIntersecting) {
                    setIntersecting(true);
                    observer.disconnect();
                }
            }
            else {
                setIntersecting(entry.isIntersecting);
            }
        }, observerOptions);
        observer.observe(ref.current);
        return () => {
            observer.disconnect();
        };
    }, [ref.current]);
    return [intersecting, ref];
}

export { useOnScreen as default };
//# sourceMappingURL=useOnScreen.js.map
